import { useAppStateStore as piniaAppStateStore } from '@/store/modules/appStateStore';
import { Project, UserInfo } from '@/types';
import StorableElementValues from '@/store/dataTransfertObject/StorableElementValues';

const appStateUpdator = {
    updateUser(user: null | UserInfo) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateUser(user);
    },
    getUser(): UserInfo | null  {
        const piniaStore = piniaAppStateStore();

        return piniaStore.getUser;
    },
    updateLogged(logged: boolean) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateLogged(logged);
    },
    isLogged() {
        const piniaStore = piniaAppStateStore();

        return piniaStore.isLogged;
    },
    updateLoaded(loaded: boolean) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateLoaded(loaded);
    },
    isLoaded() {
        const piniaStore = piniaAppStateStore();

        return piniaStore.isLoaded;
    },
    updateLoggedAt(date: Date) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateLoggedAt(date);
    },
    getLoggedAt() {
        const piniaStore = piniaAppStateStore();

        return piniaStore.getLoggedAt;
    },
    updateIsAccessMaster(isAccessMaster: boolean) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateIsAccessMaster(isAccessMaster);
    },
    updateState(user: null | UserInfo, logged: boolean, loaded: boolean) {
        this.updateUser(user);
        this.updateLogged(logged);
        this.updateLoaded(loaded);
        if (user) {
            this.updateLoggedAt(new Date());
        }
    },
    updateCurrentProject(project: Project) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateCurrentProject(project);
    },
    deleteCurrentProject() {
        const piniaStore = piniaAppStateStore();
        piniaStore.deleteCurrentProject();
    },
    getCurrentProjectStore() {
        const piniaStore = piniaAppStateStore();

        return piniaStore.getCurrentProject;
    },
    updateProjectCount(projectCount: number) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateProjectCount(projectCount);
    },
    deleteProjectCount() {
        const piniaStore = piniaAppStateStore();
        piniaStore.deleteProjectCount();
    },
    getProjectCount() {
        const piniaStore = piniaAppStateStore();

        return piniaStore.projectCount;
    },
    updateProjectStore(storableElementValues: StorableElementValues) {
        const piniaStore = piniaAppStateStore();
        piniaStore.updateProjectStore(storableElementValues);
    },
    deleteProjectStores() {
        const piniaStore = piniaAppStateStore();
        piniaStore.deleteProjectStores();
    },
    getProjectStores() {
        const piniaStore = piniaAppStateStore();

        return piniaStore.getProjectStores;
    }
};

export default appStateUpdator;